module.exports = __webpack_public_path__ + "static/media/_tilde.b73a0f6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/_tilde.jpg
// module id = 65
// module chunks = 0